function findMessage(error) {
  let errorMessage = {
    "1": "Purpose ไม่มีค่า",
    "2": "Purpose Code ไม่มีค่า",
    "3": "Purpose Code ไม่ถูกต้อง",
    "4": "สาขาผู้ซื้อไม่ถูกต้อง",
    "5": "ที่อยู่ผู้ซื้อไม่ถูกต้อง",
    "6": "กรุณาระบุ PostcodeCode ให้กับ ผู้ซื้อ",
    "7": "ชื่อผู้รับเกิน 35 ตัวอักษร",
    "8": "ขาดข้อมูล เขต/ตำบล",
    "9": "ขาดข้อมูล แขวง/อำเภอ",
    "10": "ขาดข้อมูล จังหวัด",
    "11": "เลขประจำตัวผู้เสียภาษีผิดรูปแบบ"
  }
  return errorMessage[error]
}

export default function getErrorMessage(errors) {
  let message = ["not found"]
  if (errors.length > 0) {
    message = []
    errors.forEach((error) => {
      message.push(findMessage(error))
    })
  }
  return message.toString()
}
